export default __webpack_public_path__ + "static/media/mitsubishi.ba092b0b.svg";